export class LinkImageHover {

    constructor()
    {
        let images = document.querySelectorAll('.link-image-hover-section__link__img');
        Array.from(images).forEach(img => {
            img.parentElement.parentElement.onmousemove = function (e) {
                let x = e.clientX, y = e.clientY;
                let parent_position = img.parentElement.getBoundingClientRect();
                //When title is on two lines, modify the offset dynamically
                let top_offest = img.parentElement.querySelector('.link-image-hover-section__link__title').getBoundingClientRect().height / 2;
                img.style.top = (y - 50 - top_offest - parent_position.top) + 'px';
                img.style.left = (x - 50 - parent_position.left) + 'px';
            };
        });
    }
}



// WEBPACK FOOTER //
// ./js/util/linkImageHover.js